import { gql } from 'graphql-request'

export const configurationQuery = gql`
  query GetConfiguration($siteId: String!) {
    site(id: $siteId) {
      configurations {
        timezone
        currency
      }
    }
  }
`

export const timeFormatQuery = gql`
  query GetConfiguration($siteId: String!) {
    site(id: $siteId) {
      configurations {
        timeFormat
      }
    }
  }
`
